<div [ngClass]="[modalClass ? modalClass : '']"
    [attr.data-automation-id]="(modalContainerAutomationId ? modalContainerAutomationId : modalAutomationId) + '-modal-container'"
    resModalTools [resizeHorizontal]="resizeHorizontal" [resizeHorizontalMin]="resizeHorizontalMin"
    [resizeHorizontalMax]="resizeHorizontalMax" [resizeVertical]="resizeVertical"
    [resizeVerticalMin]="resizeVerticalMin" [resizeVerticalMax]="resizeVerticalMax" [maximizable]="maximizable"
    [maximizableAutoId]="maximizableAutoId" [modalDraggable]="modalDraggable"
    [modalHasVariableHeight]="modalHasVariableHeight" [modalHasVariablePosition]="modalHasVariablePosition">
    <div class="modal-header">
        <span class="modal-title" [ngClass]="modalTitleSecondPart ? 'modal-title-right-margin' : ''" [attr.title] = "modalTitleSecondPart ? modalTitle: ''"
            [attr.data-automation-id]="(modalContainerAutomationId ? modalContainerAutomationId : modalAutomationId) + '-modal-title-label'">{{modalTitle}}</span>
        <span *ngIf="modalTitleSecondPart" [attr.data-automation-id]="(modalContainerAutomationId ? modalContainerAutomationId : modalAutomationId) + '-modal-title-label-second-part'">{{modalTitleSecondPart}}</span>
        <button type="button" [hidden]="!modalHelpIndex" [attr.data-automation-id]="modalAutomationId + '-help-button'"
            title="Help" aria-label="Help" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
        <button type="button" [hidden]="!isCloseButtonVisible" [disabled]="isCloseButtonDisabled"
            [attr.data-automation-id]="modalAutomationId + '-exit-button'" title="Close" aria-label="Close"
            (click)="closeButtonAction()" class="close-button">
            <i class="fa fa-close"></i>
        </button>
    </div>
    <div class="modal-body" [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <ng-content></ng-content>
    </div>
    <div class="modal-button-bar" *ngIf="showButtonBar">
        <button *ngIf="isCloseButtonVisible" type="button" [disabled]="isCloseButtonDisabled"
            [attr.data-automation-id]="isAddTextToSyntheticDocumentModal ? 'profile-discard-changes-button' : modalAutomationId + '-cancel-button'"
            class="secondary-button" (click)="closeButtonAction()">{{secondaryButtonLabel}}
        </button>
        <ng-container *ngTemplateOutlet="middleButtonTemplate"></ng-container>
        <button type="button" [hidden]="isPrimaryButtonHidden"
            [attr.data-automation-id]="isAddTextToSyntheticDocumentModal ? 'profile-save-button' : modalAutomationId + '-primary-button'"
            class="primary-button" (click)="primaryButtonAction()" [disabled]="!isPrimaryBtnEnabled"
            [ngClass]="[primaryButtonCustomClass ? primaryButtonCustomClass : '']"
            [attr.title]=" (verifyRequiredValidator && !isPrimaryBtnEnabled) ? 'Please complete all required fields' : titleText ">{{primaryButtonLabel}}</button>
        <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </div>
</div>